interface LoadingScreenProps {
  title?: string;
  description?: string;
}

export function LoadingScreen({
  title = "Loading your workspace",
  description = "Please wait while we set things up...",
}: LoadingScreenProps) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm z-50">
      <div className="flex flex-col items-center">
        <div className="relative w-16 h-16 mb-4">
          <div className="absolute top-0 left-0 w-full h-full rounded-full border-4 border-t-orange-500 border-r-red-500 border-b-pink-500 border-l-transparent animate-spin"></div>
        </div>
        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-200">
          {title}
        </h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
          {description}
        </p>
      </div>
    </div>
  );
}
